import * as React from "react";
import { AdminOption } from "../Types";
import { AdminOptionRow } from "./AdminOptionRow";

export const ApplicationFlowOptionsTab = ({ options }: { options: AdminOption[] }) => (
    <div>
        <table className="table no-border">
            <tbody style={{ border: "none" }}>
                {
                    options.map((opts, index) => AdminOptionRow(opts, index))
                }
            </tbody>
        </table>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/ApplicationFlowOptionsTab.tsx